<template>
    <div>
        <div style="height: 20vh;" class="inapp-hide"></div>
        <div class="v-step__update__wrapper" v-if="form.id > 0" @click="submit('update')">
            <span class="v-step__update__wrapper__btn__txt">Applica le modifiche e paga</span>
            <b-button class="v-step__update__wrapper__btn" variant="dark">
                <div class="v-step__update__wrapper__btn__icon">
                    <img height="20" src="/static/svg/icons/icon-refresh.svg">
                </div>
            </b-button>
        </div>
        <Riassunto :iscrizione="true"/>
        <div class="race-app-header inapp-show"></div>

        <div class="v-step step" v-show="conMaglia && !maglia"
             v-bind:class="{ 'active': step === 0 }"
             @click="focusStep"
             @keyup.enter.stop="next()">
            <div class="k-card" style="width:100%">
                <div class="k-card-body" style="width:100%">
                    <div class="k-card-img align-self-center">
                        <img :src="testi_donazione.maglia_img">
                    </div>
                    <div class="k-card-text" style="font-size:120%">
                        <div class="k-card-text--description" v-html="testi_donazione.maglia_testo"></div>
                    </div>
                </div>
            </div>
            <div class="v-step__footer-step">
                <b-button class="v-step__next-btn" @click="next">
                    Ok
                </b-button>
                <div class="v-step__next-info text-dark">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <!-- E-mail -->
        <div class="v-step step" v-bind:class="{ 'active': step === 1 }"
             @click="focusStep"
             @keyup.enter.stop="next('email')">

            <b-form-group label="Indirizzo e-mail">
                <b-input type="email"
                         v-model="form.email"
                         :state="state('email')"
                         placeholder="Inserisci l'e-mail"
                         data-vv-name="email"
                         data-vv-as="E-Mail"
                         :disabled="prima_iscrizione && form.id > 0"
                         v-validate="'required|email'"
                         key="email"
                ></b-input>
            </b-form-group>
            <span v-show="errors.has('email')" class="error">{{ errors.first('email') }}</span>

            <div class="help">Assicurati di inserire una mail valida per ottenere la ricevuta necessaria al ritiro del
                pacco gara
            </div>

            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('email')"
                          class="v-step__next-btn"
                          @click="next">
                    Ok
                </b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <!-- Nome, Cognome -->
        <div class="v-step step"
             v-bind:class="{ 'active': step === 2 }"
             @click="focusStep"
             @keyup.enter.stop="next('nome','cognome')">
            <b-form-group label="Dati del partecipante">
                <b-input type="text"
                         v-model="form.nome"
                         :state="state('nome')"
                         placeholder="Inserisci qui il nome"
                         ref="nome"
                         data-vv-name="nome"
                         data-vv-as="nome"
                         v-validate="'required|name'"
                         key="name"></b-input>
                <!-- Todo: gli span sono diversi -->
                <span v-show="errors.has('nome')">{{ errors.first('nome') }}</span>

                <b-input @keyup.native.enter.stop="next"
                         type="text"
                         ref="cognome"
                         v-model="form.cognome"
                         :state="state('cognome')"
                         data-vv-name="cognome"
                         placeholder="Inserisci il cognome"
                         data-vv-as="cognome"
                         v-validate="'required|name'"
                         key="cognome"></b-input>
                <!-- Todo: gli span sono diversi -->
                <span v-show="errors.has('cognome')" class="help is-danger small text-danger p-4">{{ errors.first('cognome') }}</span>

            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('nome','cognome')" class="v-step__next-btn" variant="" @click="next">
                    Ok
                </b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <div class="v-step step"
             v-bind:class="{ 'active': step == 3 }"
             @click="focusStep"
             @keyup.enter.stop="next('data_nascita')"
        >
            <b-form-group label="Data di nascita">
                <b-input type="text"
                         v-model="form.data_nascita"
                         :state="state('data_nascita')"
                         data-vv-name="data_nascita"
                         placeholder="gg-mm-aaaa"
                         autocomplete="nope"
                         v-validate="`required|date_format:dd-MM-yyyy|date_between:01-01-1900,${data_max}`"
                         data-vv-as="data di nascita"
                         key="data_nascita"
                         :formatter="data_format"></b-input>
                <span v-show="errors.has('data_nascita')" class="help is-danger small text-danger p-4">{{ errors.first('data_nascita') }}</span>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('data_nascita')" class="v-step__next-btn" variant="" @click="next">
                    Ok
                </b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 4 }"
             @click="focusStep"
             @keyup.enter.stop="!validationError && next() "
        >
            <b-form-group label="Numero di telefono">
                <b-input type="text"
                v-model="form.phone"
                    :state="state('phone')"
                    :formatter="phone_format"
                    placeholder="Per es. 347 00 00 000"
                    data-vv-name="phone"
                    data-vv-as="numero di telefono"
                    v-validate="'phone'"
                    key="phone"
                    @input="validatePhone"
                ></b-input>
            </b-form-group>
            <span v-show="errors.has('phone') && form.phone" class="error">{{ errors.first('phone') }}</span>
            <div class="v-step__footer-step">
                <b-button :disabled="validationError" class="v-step__next-btn" variant="" @click="next">
                    Ok
                </b-button>
                <div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 5 }"
             v-show="state('data_nascita') && eta >= 15"
             @click="focusStep"
             @keyup.enter.stop="next('categoria')"
        >
            <b-form-group label="In quale categoria partecipi?">
                <b-form-radio-group v-model="form.categoria" name="categoria">
                    <!-- Todo: ci sono decisamente troppe classi qui -->
                    <b-form-radio value="adulto-non-competitivo"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Adulto o bambino non competitivo - donna o uomo
                        <!-- <span 
                            class="v-tooltip-trigger"
                            @click="showTooltip('adulto', $event)">
                            ?
                            <div v-if="tooltips.adulto" class="custom-tooltip" :style="tooltipStyle">
                                Dai 15 anni compiuti in su
                            </div>
                        </span> -->
                    </b-form-radio>
                    <b-form-radio value="donna-in-rosa"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">Donna
                        in Rosa
                            <span 
                            class="v-tooltip-trigger"
                            @click="showTooltip('rosa', $event)">
                            ?
                            <div v-if="tooltips.rosa" class="custom-tooltip" :style="tooltipStyle">
                                Sono una donna che ha avuto un tumore del seno e desidero indossare la t-shirt delle Donne in Rosa.
                            </div>
                            </span>
                    </b-form-radio>
                    <br v-if="competitivi">
                    <b-form-radio value="adulto-competitivo"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline" v-if="competitivi">
                        10 km
                        – donna o uomo
                        <span 
                            class="v-tooltip-trigger"
                            @click="showTooltip('competitivi', $event)">
                            ?
                            <div v-if="tooltips.competitivi" class="custom-tooltip" :style="tooltipStyle">
                                {{ testo_competitivi }}
                            </div>
                            </span>
                    </b-form-radio>
                    <b-form-radio value="donna-in-rosa-competitiva"
                                  class="d-block v-custom-control v-custom-radio v-custom-control-inline" v-if="competitivi">10 km
                        Donna in Rosa
                        <span
                            class="v-tooltip-trigger"
                            @click="showTooltip('competitivi_rosa', $event)">
                            ?
                            <div v-if="tooltips.competitivi_rosa" class="custom-tooltip" :style="tooltipStyle">
                                {{ testo_competitivi_rosa }}
                            </div>
                            </span>
                    </b-form-radio>


                </b-form-radio-group>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('categoria')" class="v-step__next-btn" variant="primary"
                          @click="next">
                    Continua
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 6 }"
             v-show="adultoCompetitivo"
             @click="focusStep"
             @keyup.enter.stop="next('societa')"
        >
            <b-form-group label="Come partecipi alla 10 km?">
                <b-form-radio-group v-model="form.societa" name="societa">
                    <b-form-radio value="non-competitivo-10km"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Partecipo come non competitivo
                    </b-form-radio>
                    <b-form-radio value="fidal"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Fidal
                    </b-form-radio>
                    <b-form-radio value="EPS"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        <!-- EPS Ente di promozione sportiva -->
                        Runcard
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('societa')" class="v-step__next-btn" variant="" @click="next">
                    Prosegui
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 7 }"
             v-show="richiedeTessera"
             @click="focusStep"
             @keyup.enter.stop="next('nome_societa','codice_societa')"
        >
            <b-form-group label="Dati società/associazione sportiva">
                <b-input type="text"
                         v-model="form.nome_societa"
                         :state="state('nome_societa')"
                         placeholder="Numero di tessera Fidal o Runcard"
                         ref="nome_societa"
                         data-vv-name="nome_societa"
                         data-vv-as="nome_societa"
                         v-validate="{ required: true, regex: /^(?!RR999$).*$/ }"
                         key="Nome società"></b-input>
                <span v-show="errors.has('nome')" class="help is-danger small text-danger p-4">{{ errors.first('nome_societa') }}</span>

                <b-input @keyup.native.enter.stop="next"
                         type="text"
                         ref="codice_societa"
                         v-model="form.codice_societa"
                         :state="state('codice_societa')"
                         data-vv-name="codice_societa"
                         placeholder="Codice società/associazione"
                         data-vv-as="Codice società"
                         key="codice_societa"></b-input>
                <em>*Se hai una runcard il codice società da inserire e <b>RR999</b></em>
                <span v-show="errors.has('codice_societa')" class="help is-danger small text-danger p-4">{{ errors.first('codice_societa') }}</span>

            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('codice_societa','nome_societa')" class="v-step__next-btn" variant=""
                          @click="next">
                    Prosegui
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 8 }"
             v-show="check_tshirt_size === 'adult'"
             @click="focusStep"
             @keyup.enter.stop="next('taglia')"
        >
            <b-form-group label="Seleziona la taglia della t-shirt">
                <b-form-radio-group v-model="form.taglia" name="taglia">
                    <b-form-radio value="S"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        S – Small
                    </b-form-radio>
                    <b-form-radio value="M"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        M – Medium
                    </b-form-radio>
                    <b-form-radio value="L"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        L – Large
                    </b-form-radio>
                    <b-form-radio value="XL"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        XL – Extra large
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('taglia')" class="v-step__next-btn" variant="primary"
                          @click="next">Continua
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 9 }"
             v-show="check_tshirt_size === 'kid'"
             @click="focusStep"
             @keyup.enter.stop="next('taglia_minore')"
        >
            <b-form-group label="Seleziona la taglia della t-shirt (bambini)">
                <!--<div v-if="conMaglia" class="small text-uppercase">-->
                    <!--E' disponibile solo la taglia S adulto<br><br>-->
                <!--</div>-->
                <b-form-radio-group v-model="form.taglia_minore" name="taglia_minore">
                    <b-form-radio value="S"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline" style="position:relative;">
                        S - Small
                        <span 
                            class="v-tooltip-trigger" 
                            @mouseenter="tooltips.small = true"
                            @mouseleave="tooltips.small = false">
                            ?
                            <div v-if="tooltips.small" class="custom-tooltip custom-tooltip-size">
                                5/6 anni
                            </div>
                        </span>
                    </b-form-radio>
                    <b-form-radio value="M"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        M – Medium
                        <span 
                            class="v-tooltip-trigger" 
                            @mouseenter="tooltips.medium = true"
                            @mouseleave="tooltips.medium = false">
                            ?
                            <div v-if="tooltips.medium" class="custom-tooltip custom-tooltip-size">
                                7/8 anni
                            </div>
                        </span>
                    </b-form-radio>
                    <b-form-radio value="L"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        L – Large
                        <span 
                            class="v-tooltip-trigger" 
                            @mouseenter="tooltips.large = true"
                            @mouseleave="tooltips.large = false">
                            ?
                            <div v-if="tooltips.large" class="custom-tooltip custom-tooltip-size">
                                9/10 anni
                            </div>
                        </span>
                    </b-form-radio>
                    <b-form-radio value="XL"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        XL – Extra large
                        <span 
                            class="v-tooltip-trigger" 
                            @mouseenter="tooltips.extraLarge = true"
                            @mouseleave="tooltips.extraLarge = false">
                            ?
                            <div v-if="tooltips.extraLarge" class="custom-tooltip custom-tooltip-size">
                                11/12 anni
                            </div>
                        </span>
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!compiled('taglia_minore')" class="v-step__next-btn" variant="primary"
                          @click="next">Continua
                </b-button>
            </div>
        </div>

        <div class="v-step step tshirt-section" v-bind:class="{ 'active': step === 10 }"
             v-show="conMaglia"
             @click="focusStep"
             @keyup.enter.stop="next(check_maglia)"
        >
            <b-form-group label="Maglia Race">
                <div>
                    <div class="text-center h5 m-0 pr-lg-10" style="letter-spacing: 1px;" v-if="!this.wire_transfer">
                        Vuoi ricevere a casa la maglia ufficiale e lo zainetto della <br>
                        Race for the Cure?
                    </div>
                    <div class="v-step__next__wrapper-btn d-block w-100 text-center mt-4 pl-lg-4 pr-lg-10" v-if="!this.wire_transfer">
                        <a class="denied-btn"
                           :class="{'selected':form.maglia === 1}" @click="form.maglia = 0; next()">No, la ritirerò di persona</a>
                        <a class="accepted-btn"
                           :class="{'selected':form.maglia === 0}" @click="form.maglia = 1; copy_inMaglia()">Sì, spediscila</a>
                    </div>
                    <div class="text-center h5 m-0 pr-lg-10" style="letter-spacing: 1px;">
                        <br><br><span class="mb-3 text-secondary font-italic small">
                            <strong>
                                PARLA DELL’IMPORTANZA DELLA PREVENZIONE</strong>: Indossa la maglia per gli allenamenti quotidiani, per la corsa al parco, regalala ad amici e colleghi.<br>
                                Condividi le tue foto sui social e tagga @komenitalia</span>
                    </div>

                </div>
                <div class="rounded mt-5 border border-secondary" v-if="form.maglia == 1 && !imposta_maglia">
                    <!--<div class="font-weight-bold small text-uppercase mb-2">La maglia verrà spedita a</div>-->
                    <div class="py-1 px-2 bg-secondary text-white d-flex align-items-center justify-content-start small text-uppercase">
                        <img src="/static/svg/icons/icon-delivery.svg" height="40">
                        <div class="ml-2">Consegna a domicilio</div>
                    </div>
                    <div class="small pt-3 px-4 pb-4 m-0 d-inline-block text-secondary">
                        Questa maglia e questo zainetto verranno spediti, insieme agli altre senza costi aggiuntivi a
                        <br>{{maglia.nome}} {{maglia.cognome}}, {{maglia.indirizzo}}, {{maglia.citta}} &mdash; {{maglia.cap}} ({{maglia.provincia}})
                        <br>Le spese di spedizione vengono applicate ogni {{testi_donazione.maglia_num}} kit inviati a casa!
                    </div>
                    <div class="py-2 px-2 bg-secondary text-white d-flex align-items-center justify-content-end small text-uppercase">
                        <div class="btn btn-sm btn-light" @click="next">Continua</div>
                    </div>
                    <!--<div class="d-inline-block">{{maglia.indirizzo}}</div>-->
                    <!--<div class="d-inline-block">{{maglia.citta}} - {{maglia.cap}} ({{maglia.provincia}}</div>-->
                </div>
                <div v-if="form.maglia == 1 && imposta_maglia">

                    <div class="small mt-5 mb-3 text-uppercase text-secondary">Compila l'indirizzo per ricevere la maglia e lo zainetto</div>

                    <b-input-group class="bg-transparent border-0 text-dark">
                        <b-input v-model="form.maglia_nome"
                                 :state="state('maglia_nome')"
                                 placeholder="Nome"
                                 autocomplete="nope"
                                 data-vv-name="maglia_nome"
                                 data-vv-as="nome indirizzo spedizione"
                                 key="maglia_nome"
                                 v-validate="'required|name'"
                        ></b-input>
                    </b-input-group>
                    <span v-show="errors.has('maglia_nome')" class="error">{{ errors.first('maglia_nome') }}</span>

                    <b-input-group class="bg-transparent border-0 text-dark">
                        <b-input v-model="form.maglia_cognome"
                                 :state="state('maglia_cognome')"
                                 placeholder="Cognome"
                                 autocomplete="nope"
                                 data-vv-name="ref_cognome"
                                 key="maglia_cognome"
                                 data-vv-as="cognome indirizzo spedizione"
                                 v-validate="'required|name'"
                        ></b-input>
                    </b-input-group>
                    <span v-show="errors.has('maglia_cognome')"
                          class="error">{{ errors.first('maglia_cognome') }}</span>

                    <b-input-group class="bg-transparent border-0 text-dark">
                        <b-input v-model="form.maglia_cellulare"
                                 :state="state('maglia_cellulare')"
                                 placeholder="Recapito telefonico"
                                 autocomplete="nope"
                                 data-vv-name="maglia_cellulare"
                                 key="maglia_cognome"
                                 data-vv-as="recapito telefonico spedizione"
                                 v-validate="'required|phone'"
                        ></b-input>
                    </b-input-group>
                    <span v-show="errors.has('maglia_cellulare')" class="error">{{ errors.first('maglia_cellulare') }}</span>


                    <b-input-group class="bg-transparent border-0 text-dark">
                        <b-input v-model="form.maglia_indirizzo"
                                 :state="state('maglia_indirizzo')"
                                 placeholder="Indirizzo per la spedizione"
                                 autocomplete="nope"
                                 data-vv-name="maglia_indirizzo"
                                 key="maglia_indirizzo"
                                 data-vv-as="indirizzo spedizione"
                                 v-validate="'required|min:3'"
                        ></b-input>
                    </b-input-group>
                    <span v-show="errors.has('maglia_indirizzo')" class="error">{{ errors.first('maglia_indirizzo') }}</span>

                    <b-input-group class="bg-transparent border-0 text-dark">
                        <b-input v-model="form.maglia_citta"
                                 :state="state('maglia_citta')"
                                 placeholder="Città per la spedizione"
                                 autocomplete="nope"
                                 data-vv-name="maglia_citta"
                                 key="maglia_citta"
                                 data-vv-as="città spedizione"
                                 v-validate="'required|min:3'"
                        ></b-input>
                    </b-input-group>
                    <span v-show="errors.has('maglia_citta')"
                          class="error">{{ errors.first('maglia_citta') }}</span>


                    <b-input-group class="bg-transparent border-0 text-dark">
                        <b-input v-model="form.maglia_cap"
                                 :state="state('maglia_cap')"
                                 placeholder="CAP"
                                 autocomplete="nope"
                                 data-vv-name="maglia_cap"
                                 key="maglia_cap"
                                 data-vv-as="cap spedizione"
                                 v-validate="'required|min:3|numeric'"
                        ></b-input>
                    </b-input-group>
                    <span v-show="errors.has('maglia_cap')" class="error">{{ errors.first('maglia_cap') }}</span>

                    <b-input-group class="bg-transparent border-0 text-dark select-wrapper" append="Provincia">
                        <b-form-select v-if="province"
                                       v-model="form.maglia_provincia"
                                       :options="province"
                                       class="bg-transparent border-0 mb-1 text-dark"
                                       style="border-bottom: 1px solid #000 !important"
                                       data-vv-name="maglia_provincia"
                                       key="maglia_provincia"
                                       data-vv-as="provincia spedizione"
                        ></b-form-select>
                    </b-input-group>
                    <span v-show="errors.has('maglia_provincia')" class="error">{{ errors.first('maglia_provincia') }}</span>
                    <div class="v-step__footer-step">
                        <b-button :disabled="!check_maglia" class="v-step__next-btn" variant="primary"
                                  @click="next">Continua
                        </b-button>
                    </div>
                </div>
            </b-form-group>
            <div class="tshirt-section__image"><img src="../../assets/images/race_25.png"></div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 11 }"
             @click="focusStep"
             @keyup.enter.stop="next(check_privacy)"
        >                <!-- Todo: inserire qui il link alla privacy -->
            <div class="small mb-5"><a class="text-dark border-light border-bottom pb-1"
                                       href="https://www.raceforthecure.it/consensi-la-race-cure" target="_blank">Ho
                letto l'informativa completa</a></div>
            <b-form-group label="Consensi per la Race for the Cure">
                <div v-if="is_regalo">
                    <span class="small">L'iscritto riceverà un e-mail per confermare i consensi necessari per partecipare alla gara. Non puoi procedere tu direttamente, ma sono in ogni caso necessari per poter partecipare.</span>
                </div>
                <div v-else>
                    <div class="small mt-5" v-if="minore">
                        In quanto minorenne, il genitore/tutore deve compilare i seguenti consensi
                    </div>

                    <!-- Todo: si vedono male -->
                    <div class="d-flex align-items-center justify-content-between"
                         v-if="prima_iscrizione && eta_attuale >= 18&& !is_regalo ">
                        <span v-if="!donna_in_rosa">Desidero ricevere contatti informativi istituzionali personalizzati sulle attività di Komen Italia</span>
                        <span v-if="donna_in_rosa">Desidero ricevere contatti informativi istituzionali personalizzati sulle attività di Komen Italia per le Donne in Rosa</span>
                        <div class="v-step__next__wrapper-btn">
  <div>
    <a class="text-uppercase small p-2 cursor_pointer clickable-link"
       :class="{ 'text-dark': form.check_generico !== 1, 'text-white': form.check_generico === 1, 'selected':form.check_generico === 1 }"
       @click="form.check_generico = 1">Si</a>

    <a class="text-uppercase small p-2 cursor_pointer clickable-link"
       :class="{ 'text-dark': form.check_generico !== 0, 'text-white': form.check_generico === 0, 'selected':form.check_generico === 0 }"
       @click="form.check_generico = 0">No</a>
  </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mt-3" v-if="minore && !is_regalo">
                        <span class="option d-block">Consenso per il trattamento dei dati di minori per i soli scopi organizzativi dell’evento</span>
                        <div class="v-step__next__wrapper-btn">
                            <a class="text-uppercase small p-2 cursor_pointer clickable-link"
                               :class="{'text-dark':form.check_minore!==1,'text-white':form.check_minore===1,'selected':form.check_minore === 1}" @click="form.check_minore = 1">Si</a>
                            <a class="text-uppercase small p-2 cursor_pointer clickable-link"
                               :class="{'text-dark':form.check_minore!==0,'text-white':form.check_minore===0,'selected':form.check_minore === 0}" @click="form.check_minore = 0">No</a>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mt-3"
                         v-if="prima_iscrizione && donna_in_rosa && !is_regalo">
                        <span>Consenso per il trattamento dei dati sulla salute</span>
                        <div class="v-step__next__wrapper-btn">
                            <a class="text-uppercase small p-2 cursor_pointer clickable-link"
                               :class="{'text-dark':form.check_salute!==1,'text-white':form.check_salute===1,'selected':form.check_salute === 1}" @click="form.check_salute = 1">Si</a>
                            <a class="text-uppercase small p-2 cursor_pointer clickable-link"
                               :class="{'text-dark':form.check_salute!==0,'text-white':form.check_salute===0,'selected':form.check_salute === 0}" @click="form.check_salute = 0">No</a>
                        </div>
                    </div>

                    <div class="small mt-5 error" v-if="!check_privacy">Devi effettuare una scelta per ogni opzione per
                        poter
                        procedere
                    </div>
                    <span class="small" v-if="!prima_iscrizione && !minore">L'iscritto riceverà un e-mail per confermare i consensi necessari per partecipare alla gara. Non puoi procedere tu direttamente, ma sono in ogni caso necessari per poter partecipare.</span>

                </div>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button :disabled="!check_privacy" class="v-step__next-btn" variant="" @click="next">
                    Prosegui
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 12 }"
             @click="focusStep"
             v-show="!form.maglia"
             @keyup.enter.stop="next()">
            <div class="v-step__question" 
            v-if="!(this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms)>0)"
            >L'iscrizione per questa Race prevede una donazione minima di <strong>{{
                testi_donazione.base }}&euro;</strong></div>
            <div class="v-step__question" 
            v-if="(this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms)>0)"
            >In caso di pagamento con Cumulativa online la squadra si occuperà della tua donazione, ma se vuoi aggiungere un'ulteriore donazione puoi farlo da qui.</div>
            <div class="v-step__footer-step">
                <b-button :disabled="!check_privacy" class="v-step__next-btn" variant="" @click="next">
                    Prosegui
                </b-button>
            </div>
        </div>

        <div class="v-step step" v-bind:class="{ 'active': step === 13 }"  style="padding-top:100px;"
             @keyup.enter.stop="next(step_ok_donextra)"
             v-if="testi_donazione !== null"
             @click="focusStep">
            <b-form-group
                    label="Vuoi fare una donazione aggiuntiva?"
            >
                <div class="k-card details-dashboard-container" style="width:100%">
                    <div class="k-card-body w-100" style="width:100%; border-radius:15px !important;">
                        <div class="k-card-img align-self-center">
                            <img :src="testi_donazione.path_img">
                        </div>
                        <div class="k-card-text">
                            <div class="k-card-text--title">{{ testi_donazione.titolo }}</div>
                            <div class="k-card-text--description" v-html="testi_donazione.testo"></div>
                            <!-- <a @click="show_modale_progetto" class="k-card-text--btn cursor_pointer">Dettagli
                                Progetto</a> --> 
                        </div>
                    </div>
                </div>


                <b-form-radio-group v-model="form.don_extra" name="don_extra" @input="checkFocus">
                    
                    <b-form-radio :value="testi_donazione.extra1"
                        class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Dono {{ testi_donazione.extra1 }}&euro; in più
                    </b-form-radio>
                    <b-form-radio :value="testi_donazione.extra2" class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                        Dono {{ testi_donazione.extra2 }}&euro; in più
                    </b-form-radio>

                    <b-form-radio value="extra"
                        class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline"
                        ref="extra"
                        v-if="this.is_gold_doner !== true">
                        Importo libero
                        <b-input-group class=" text-dark">
                            <b-input type="text"
                                v-model="form.don_extra_importo"
                                :state="state('don_extra_importo')"
                                append="€"
                                class="v-form-control v-form-control__euro"
                                placeholder="Scrivi l'importo desiderato"
                                data-vv-name="don_extra_importo"
                                data-vv-as="importo donazione extra"
                                @keyup.native.enter.stop="next"
                                @input="focusExtra"
                                ref="inp_extra"
                                v-validate="'decimal'"
                                key="extra"
                            ></b-input>
                            &euro; in più
                            <!-- Todo: ridurre lo spazio del campo scrivi l'importo desiderato in modo che sia a filo dell'euro -->
                        </b-input-group>
                    </b-form-radio>
                    <b-form-radio value="gold_extra"
                                  ref="gold_extra"
                                  v-if="this.is_gold_doner === true"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline">
                                  <!-- Desidero diventare SOSTENITORI GOLD con una donazione di: {{ testi_donazione.donazione_gold }}&euro; in più -->
                                  <div class="d-flex flex-column flex-md-row align-items-md-center">
                                    <div class="d-none d-md-block order-md-1 mr-2">
                                        Dono {{ this.gold_amount }}€ in più e divento SOSTENITORE GOLD. Dono {{ this.super_gold_amount }}€ in più e divento SOSTENITORE SUPER GOLD.
                                    </div>
                                    <div class="d-block d-md-none order-1">
                                        Dono {{ this.gold_amount }}€ in più e divento SOSTENITORE GOLD. Dono {{ this.super_gold_amount }}€ in più e divento SOSTENITORE SUPER GOLD.
                                    </div>
                                    <div class="order-2 order-md-3 pr-0 pr-md-2">
                                        <!-- input group here -->
                                    <b-input-group class="bg-transparent border-0 text-dark d-flex flex-row flex-nowrap align-items-center w-100 w-lg-auto pr-md-5" style="max-width: 200px;">
                                    <b-input type="number"
                                             v-model="form.don_gold_extra"
                                             :state="state('don_gold_extra')"
                                             append="€"
                                             class="v-form-control v-form-control__euro p-0 pl-md-2 pr-md-2 text-left text-md-right"
                                             :placeholder="isInputFocused ? '' : 'Scrivi qui l\'importo'"
                                             data-vv-name="don_gold_extra"
                                             data-vv-as="gold donazione extra"
                                             @keyup.native.enter.stop="next"
                                             @input="focusGoldExtra"
                                             @focus="onInputFocus"
                                             @blur="onInputBlur"
                                             ref="inp_gold_extra"
                                             v-validate="'decimal'"
                                             key="gold_extra"
                                    ></b-input>&euro;
                                    
                                    <!-- Todo: ridurre lo spazio del campo scrivi l'importo desiderato in modo che sia a filo dell'euro -->
                                </b-input-group>
                                    </div>
                                    <div class="d-block d-md-none order-3 mt-1">
                                    </div>
                                </div>
                            </b-form-radio>
                            <span v-if="!gold_check"  class="error">ATTENZIONE: Se vuoi diventare sostenitore gold e ricevere lo speciale kit, la donazione minima aggiuntiva richiesta è di {{this.gold_amount}} euro.</span>


                    <b-form-radio value="0"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline"
                                  data-vv-name="don_extra"
                                  v-if="!(this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms)>0)">
                                  <!-- No, va bene la donazione minima di {{ donazione_base }}&euro; -->
                                  No, non voglio fare una donazione aggiuntiva
                    </b-form-radio>
                    <b-form-radio value="0"
                                  class="d-block mb-2 v-custom-control v-custom-radio v-custom-control-inline"
                                  data-vv-name="don_extra"
                                  v-if="(this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms)>0)">
                                  No, non voglio fare una donazione aggiuntiva
                    </b-form-radio>
                    <div v-if="this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms)>0" class="help">
                        * In caso di pagamento con Cumulativa online la squadra si occuperà della tua donazione, ma se vuoi aggiungere un'ulteriore donazione puoi farlo da qui.
                    </div>
                </b-form-radio-group>
            </b-form-group>
            <div class="v-step__footer-step">
                <b-button
                        :disabled="!gold_check || (!step_ok_donextra && !(this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms)>0))"
                        class="v-step__next-btn" variant="primary"
                        v-show="form.id === null"
                        @click="next">Continua
                </b-button>
            </div>
        </div>

        <div class="v-step step"  v-show="prima_iscrizione && !check_wire_no_pay" v-bind:class="{ 'active': true }">
            <b-form-group label="Dati del donatore">
                <div class="help">
                    <strong>Dati relativi a chi effettua la donazione</strong>
                    <br/>
                    Tutte le donazioni a favore di Komen sono fiscalmente deducibili o detraibili secondo i limiti indicati dalla legge<br>
                </div>
                <b-input type="email"
                         v-model="form.donatore_email"
                         :state="state('donatore_email')"
                         @blur="changeDonatoreEmail"
                         placeholder="E-Mail donatore"
                         data-vv-name="donatore_email"
                         data-vv-as="E-Mail"
                         v-validate="donation_data_validation(!check_wire_no_pay,'required|email')"
                         key="donatore_email"
                ></b-input>
                <span v-if="errors.has('donatore_email')" class="error">{{ errors.first('donatore_email') }}</span>

                <b-input type="text"
                         v-model="form.donatore_nome"
                         :state="state('donatore_nome')"
                         placeholder="Nome donatore"
                         ref="donatore_nome"
                         data-vv-name="donatore_nome"
                         data-vv-as="donatore_nome"
                         v-validate="donation_data_validation(!check_wire_no_pay,'required|name')"
                         :disabled="prima_iscrizione && form.id > 0"
                         key="name"></b-input>
                <span v-if="errors.has('donatore_nome')"  class="error">{{ errors.first('donatore_nome') }}</span>

                <b-input
                         type="text"
                         ref="donatore_cognome"
                         v-model="form.donatore_cognome"
                         :state="state('donatore_cognome')"
                         data-vv-name="donatore_cognome"
                         placeholder="Cognome donatore"
                         data-vv-as="donatore_cognome"
                         v-validate="donation_data_validation(!check_wire_no_pay,'required|name')"
                         :disabled="prima_iscrizione && form.id > 0"
                         key="donatore_cognome"></b-input>
                <span v-if="errors.has('donatore_cognome')" class="error">{{ errors.first('donatore_cognome') }}</span>
                <b-input
                         type="text"
                         ref="donatore_cf"
                         v-model="form.donatore_cf"
                         :state="state('donatore_cf')"
                         :disabled="prima_iscrizione && form.id > 0"
                         data-vv-name="donatore_cf"
                         placeholder="Codice Fiscale"
                         data-vv-as="donatore_cf"
                         key="donatore_cf"></b-input>
                <b-input
                         type="text"
                         ref="donatore_ragionesociale"
                         v-model="form.donatore_ragionesociale"
                         :state="state('donatore_ragionesociale')"
                         :disabled="prima_iscrizione && form.id > 0"
                         data-vv-name="donatore_ragionesociale"
                         placeholder="Ragione Sociale ( se azienda )"
                         data-vv-as="donatore_cognome"
                         key="donatore_ragionesociale"></b-input>
                <b-input
                         type="text"
                         ref="donatore_piva"
                         v-model="form.donatore_piva"
                         :state="state('donatore_piva')"
                         :disabled="prima_iscrizione && form.id > 0"
                         data-vv-name="donatore_piva"
                         placeholder="P.IVA ( se azienda )"
                         data-vv-as="donatore_piva"
                         key="donatore_piva"></b-input>

            </b-form-group>

            <!-- <div class="help">
                Questi dati sono relativi a chi effettua la donazione<br>
                Tutti i dati che chiederemo da questo momento in poi sono invece relativi a chi effettivamente parteciperà alla race
            </div> -->

            <!--<div class="v-step__footer-step">-->
                <!--<b-button :disabled="!compiled('donatore_email','donatore_nome','donatore_cognome','donatore_cf')"-->
                          <!--class="v-step__next-btn"-->
                          <!--@click="next">-->
                    <!--Ok-->
                <!--</b-button>-->
                <!--<div class="v-step__next-info">Premi <b>INVIO</b> per continuare</div>-->
            <!--</div>-->

        </div>

        <div class="v-step v-step__next step" v-bind:class="{ 'active': step >= 14 }"
             v-if="form.id === null"

             @click="focusStep">
            <!-- Todo: questi si/no li sistemerei -->
            <div class="v-step__next__title">Vuoi iscrivere un'altra persona?</div>
            <div v-if="donazione_totale" class="v-step__next__subtitle" >Per questa iscrizione donerai <span>{{ donazione_totale }}&euro;</span>
            </div>
            <div class="v-step__next__wrapper-btn">
                <b-button class="v-step__next__wrapper-btn__option v-step__next__wrapper-btn__option--secondary mr-3"
                          :class="{loader: submit_no_loader}"
                          variant="secondary"
                          @click="submit(false)">
                    <span v-if="submit_no_loader"><img src="/static/svg/loader.svg" height="20"></span>
                    <span class="text-primary">No</span>
                </b-button>
                <b-button class="v-step__next__wrapper-btn__option"
                          @click="submit(true)"
                          variant="primary"
                          :class="{loader: submit_si_loader}"
                          v-if="this.wire_transfer === false || (this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms - 1)>0)">
                    <span v-if="submit_si_loader"><img src="/static/svg/loader.svg" height="20"></span>
                    <span>Si, aggiungi</span>
                </b-button>
            </div>
        </div>

        <b-modal ref="modale_progetto" centered class="modal__race" lazy hide-footer>
            <div v-html="html_modale"></div>
        </b-modal>

        <div class="text-center pb-8">
            <div v-if="partner_principale" class="text-uppercase small pb-1">Partner</div>
            <div v-if="partner_principale" class="d-block pb-4 partner">
                <img :src=partner_principale height="60" class="img-fluid">
            </div>

            <!--<div v-if="partner_secondari" class="text-uppercase small pb-1">Local Major Partner</div>-->
            <div v-if="partner_secondari" class="d-block partner">
                <img :src=partner_secondari height="40">
            </div>
        </div>
        <div style="height: 30vh;"></div>
    </div>
</template>


<script>
    import BaseForm from "../BaseForm";
    import forEach from "lodash/forEach"
    import Riassunto from "./Riassunto";
    import {events} from './events'
    
    export default {
        name: "InserimentoDati",
        components: {Riassunto},
        extends: BaseForm,
        mounted() {
            this.$nextTick(() => {
                if (this.$route.name === 'inserimento-dati') {
                    window.addEventListener('beforeunload', this.handleBeforeUnload);
                }
            this.data_max = this.$util.format_date(new Date(), 'DD-MM-YYYY')
            this.onMount()
            })
        },
        data() {
            return {
                tooltips: {
                    adulto: false,
                    rosa: false,
                    competitivi: false,
                    competitivi_rosa: false,
                    small: false,
                    medium: false,
                    large: false,
                    extraLarge: false
                },
                tooltipTimers: {},
                tooltipStyle: {
                    top: '0px',
                    left: '0px'
                },
                form: {
                    nome: null,
                    cognome: null,
                    data_nascita: null,
                    email: null,
                    categoria: null,
                    phone: '',
                    taglia: null,
                    taglia_minore: null,
                    societa: null,
                    nome_societa: null,
                    codice_societa: null,
                    don_extra: null,
                    don_gold_extra: null,
                    don_extra_importo: null,
                    token: null,
                    password: null,
                    check_generico: null,
                    check_minore: null,
                    check_salute: null,
                    donazione: null,
                    payer_id: null,
                    id: null,
                    maglia: null,
                    maglia_nome: null,
                    maglia_cognome: null,
                    maglia_indirizzo: null,
                    maglia_cap: null,
                    maglia_citta: null,
                    maglia_provincia: null,
                    maglia_cellulare: null,
                    donatore_piva: null,
                    donatore_ragionesociale: null,
                    donatore_cognome: null,
                    donatore_nome: null,
                    donatore_email: null,
                    donatore_cf: null,
                    is_regalo: false,
                    prima_iscrizione: false,
                    wire_transfer_method: false,
                    is_gold_doner: false,
                    validationError: false
                },
                email_status: null,
                time_to_next_msg: null,
                submit_si_loader: false,
                submit_no_loader: false,
                submit_update_loader: false,
                email_loader: false,
                data_max: null,
                id_form: null,
                prima_iscrizione: false,
                default_mail: null,
                html_modale: null,
                province: null,
                wire_transfer: false,
                wire_transfer_register_limit: null,
                registered_users: null,
                number_of_forms: 0,
                is_gold_doner: false,
                gold_amount: null,
                super_gold_amount: null,
                isInputFocused: false,
            }
        }
        ,
        methods: {
            validatePhone() {
                // Custom validation logic for phone number
                const reg = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
                
                const isValid = reg.test(this.form.phone) && this.form.phone.length > 8;
                this.errors.remove('phone'); 
                if (!isValid && this.form.phone.trim() !== '') {
                    this.errors.add({
                        field: 'phone',
                        msg: 'Inserisci un numero di telefono valido'
                    });
                    this.validationError = true; // Set validation error flag
                } else {
                    this.validationError = false; // Clear validation error flag
                }
            },
            onInputFocus() {
                this.isInputFocused = true;
            },
            onInputBlur() {
                this.isInputFocused = false;
            },

            handleBeforeUnload(event) {
                // Display a custom error message
                const message = 'You have unsaved changes. Are you sure you want to leave?';
                event.returnValue = message; // Standard for most browsers
                return message; // For some older browsers
            },
            getAge(birthDate) {
                let data_race = this.$store.state.data_race
                let age = data_race.getFullYear() - birthDate.getFullYear();
                let m = data_race.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && data_race.getDate() < birthDate.getDate())) {
                    age--;
                }
                return age;
            },
            getActualAge(birthDate) {
                let data = new Date()
                let age = data.getFullYear() - birthDate.getFullYear();
                let m = data.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && data.getDate() < birthDate.getDate())) {
                    age--;
                }
                return age;
            }, focusExtra() {
                if (this.form.don_extra_importo === '') return
                if (this.form.don_extra === 'extra') return
                this.form.don_extra = 'extra'

                if (this.$refs.extra)
                    this.$refs.extra.$el.querySelector('input').checked = true
            },focusGoldExtra() {
                if (this.form.don_gold_extra === '') return
                if (this.form.don_extra === 'gold_extra') return
                this.form.don_extra = 'gold_extra'

                if (this.$refs.gold_extra)
                    this.$refs.gold_extra.$el.querySelector('input').checked = true
            }, checkFocus() {
                if (this.form.don_extra !== 'extra'){
                    this.form.don_extra_importo = '';
                }
                if (this.form.don_extra !== 'gold_extra') {
                    this.form.don_gold_extra = '';
                }
            }, show_modale_progetto() {
                let elem = document.getElementById('modale_progetto')
                this.html_modale = elem.innerHTML
                this.$refs.modale_progetto.show()
            }, submit(newRecord) {
                if (newRecord === 'update')
                    this.submit_update_loader = true
                else if (newRecord)
                    this.submit_si_loader = true
                else
                    this.submit_no_loader = true

                if (this.eta < 15) {
                    this.form.taglia = null
                    this.form.categoria = 'bambino'
                } else this.form.taglia_minore = null
                this.form.is_regalo = this.form.prima_iscrizione = 0
                if (this.is_regalo) this.form.is_regalo = 1
                if (this.$store.getters.primo_inserimento) this.form.p = 1

                if (this.form.societa === 'non-competitivo-10km') {
                    if (this.form.categoria === 'adulto-competitivo') {
                        this.form.categoria = 'adulto-non-competitivo'
                    } else if (this.form.categoria === 'donna-in-rosa-competitiva') {
                        this.form.categoria = 'donna-in-rosa'
                    }
                    this.form.societa = null
                }

                if (!this.adultoCompetitivo)
                    this.form.societa = null

                let isEditing = this.form.id !== null
                if (!this.form.don_extra) this.form.don_extra = 0;
                
                if(this.form.don_extra === 'gold_extra'){
                    if(this.form.don_gold_extra) {
                        if(parseInt(this.form.don_gold_extra) < this.gold_amount) {
                            this.$notify({text: `C'per i donatori d'oro, l'importo minimo non può essere inferiore all ${this.gold_amount}`, duration:10000,type:'warn'})
                            this.submit_si_loader = false;
                            this.submit_no_loader = false;
                            return;
                        }
                        this.form.don_extra_importo = this.form.don_gold_extra;
                        this.form.don_extra = this.form.don_gold_extra;
                    } else {
                        this.$notify({text: `C'per i donatori d'oro, l'importo minimo non può essere inferiore all ${this.gold_amount}`, duration:10000,type:'warn'})
                            this.submit_si_loader = false;
                            this.submit_no_loader = false;
                            return;
                    }
                }

                if(this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms )>0) {
                    this.form.wire_transfer_method = true;
                } else {
                    this.form.wire_transfer_method = false;
                }

                if(this.is_gold_doner) {
                    this.form.is_gold_doner = true
                } else {
                    this.form.is_gold_doner = false
                }
                if(this.check_wire_no_pay){
                    this.form.donatore_nome = this.form.nome
                    this.form.donatore_cognome = this.form.cognome
                    this.form.donatore_email = this.form.email
                    this.form.donatore_cf = "wiretransfer"
                }
                this.$store.dispatch({
                    type: 'submit',
                    data: this.form,
                    id_form: this.id_form,
                    url: '/race/form/inserimento_dati'
                }).then((response) => {
                    this.submit_si_loader = false
                    this.submit_no_loader = false
                    this.submit_update_loader = false
                    this.$store.commit('donazione', response.data.donazione)
                    this.form.donazione = response.data.donazione
                    this.number_of_forms = this.$store.getters.next_id_form

                    if (!this.form.payer_id) {
                        this.$store.commit('payer_id', response.data.payer_id)
                        this.form.payer_id = response.data.payer_id
                    }
                    if (isEditing)
                        this.$notify({
                            text: this.form.nome + ' ' + this.form.cognome + ' modificato con successo!',
                            duration: 10
                        })
                    else
                        this.$notify({
                            text: this.form.nome + ' ' + this.form.cognome + ' iscritto con successo!',
                            duration: 10
                        })

                    let data = this.handleBeforeUnload 
                    if (isEditing) {
                        // Riapro la modale
                        events.$emit('show_modal', data)
                    } else if (newRecord) {

                        this.$router.push({
                            name: 'inserimento-dati',
                            params: {id: this.$store.getters.next_id_form}
                        })
                    } else {
                        // Apro la modale così da lì può pagare
                        events.$emit('show_modal', data)
                    }
                }, () => {
                    this.submit_si_loader = false;
                    this.submit_no_loader = false;
                })

            }, onMount() {
                this.form.donazione = this.$store.state.donazione
                this.form.payer_id = this.$store.state.payer_id
                this.$validator.reset()
                // this.toTop()
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Optional: animated smooth scroll
                });
                if (this.id_form === null)
                    this.updateFromStore(this.$route.params['id'])
                if(!this.$store.getters.team && this.$store.getters.path_chosen != "iscrizione-semplice" && this.$store.getters.path_chosen != "regala-iscrizione") {
                    if (this.$route.name === 'inserimento-dati') {
                        window.removeEventListener('beforeunload', this.handleBeforeUnload);
                    }
                    this.$router.push({
                        name: 'first-choice',
                    })
                }
                if(this.$store.getters.team) {
                    this.getWireInfo()
                }
                this.getRaceInfo()
                this.getGoldAmount()
                // Verifico se ho già dei dati salvati

                // Verifico se è il primo form
                this.prima_iscrizione = this.$store.getters.primo_inserimento
                if (this.prima_iscrizione) {
                    let dati_def = this.$store.getters.default_data
                    if (dati_def) {
                        this.form.nome = dati_def.nome
                        this.form.cognome = dati_def.cognome
                        this.form.email = dati_def.email
                        this.form.phone = dati_def.phone
                        this.default_mail = dati_def.email

                        setTimeout(() => {
                            this.$validator.validate('email')
                            if (dati_def.nome) this.$validator.validate('nome')
                            if (dati_def.cognome) this.$validator.validate('cognome')
                            if (dati_def.phone) this.$validator.validate('phone')
                        }, 200)
                    }
                }
            }, updateFromStore(id_form) {
                let data = this.$store.getters.get_by_id(id_form)
                if (data) {
                    this.id_form = id_form
                    this.form = data
                } else {
                    this.id_form = null
                }


                if (this.id_form === null) {
                    let newForm = {}
                    forEach(this.form, function (val, key) {
                        newForm[key] = null
                    })
                    this.$store.commit('new_form', newForm)
                    this.form = newForm
                    this.id_form = this.$store.getters.lastest_form
                    this.onMount()
                    // this.$router.replace({name: route_name, params: {id: this.id_form}})
                }
                this.$validator.reset()
            }, update() {
                this.submit('update')
            }, copy_inMaglia() {
                if (this.province == null)
                {
                    this.$http.get('/race/form/inserimento_dati/?type=province')
                        .then(response => {
                            this.province = response.data.province
                        }, () => {
                            this.$notify({text:'C\'è stato un problema nel processare la tua richiesta, riprova più tardi',duration:10,type:'warn'})
                        })
                }

                if (!this.imposta_maglia) return true

                if (this.form.maglia_nome === null) {
                    this.form.maglia_nome = this.form.nome
                    this.form.maglia_cognome = this.form.cognome
                    this.form.maglia_cellulare = this.form.phone
                }
            }, getWireInfo() {
                this.$http.get('/race/form/selezione_team/?type=get_wire_info'  +
                    '&id_team=' + this.$store.getters.team.id +
                    '&id_race=' + this.$store.state.id_race
                ).then(response => {
                        // console.log(response);
                        if(response.data.teams[0].wire_transfer === true && response.data.teams[0].wire_transfer_register_limit <= response.data.teams[0].registered_users){
                            this.wire_transfer = false
                        } else {
                            this.wire_transfer = response.data.teams[0].wire_transfer
                        }
                        this.wire_transfer_register_limit = response.data.teams[0].wire_transfer_register_limit,
                        this.registered_users = response.data.teams[0].registered_users
                    }, () => {
                        this.$notify({text:'C\'è stato un problema nel processare la tua richiesta, riprova più tardi',duration:10,type:'warn'})
                    })
            }, getRaceInfo() {
                this.is_gold_doner = this.$store.getters.get_gold.is_gold
            }, getGoldAmount() {
                this.gold_amount = this.$store.getters.get_gold_amount.gold_amount
                this.super_gold_amount = this.$store.getters.get_super_gold_amount.super_gold_amount
            },donation_data_validation(condition, validation) {
                if(condition) {
                    return validation
                }
                return null
            },
            toggleTooltip(ref) {
                // Close all other tooltips
                Object.keys(this.tooltips).forEach(k => {
                    if (k !== ref) {
                        this.tooltips[k] = false;
                        if (this.tooltipTimers[k]) {
                            clearTimeout(this.tooltipTimers[k]);
                        }
                    }
                });

                // Toggle current tooltip
                this.tooltips[ref] = !this.tooltips[ref];

                // Clear existing timer if any
                if (this.tooltipTimers[ref]) {
                    clearTimeout(this.tooltipTimers[ref]);
                }

                // Set auto-close timer if tooltip is open
                if (this.tooltips[ref]) {
                    this.tooltipTimers[ref] = setTimeout(() => {
                        this.tooltips[ref] = false;
                    }, 3000);
                }
            },
            showTooltip(key, event) {
                this.toggleTooltip(key)
                if (this.tooltips[key]) {
                    // Position tooltip
                    const rect = event.target.getBoundingClientRect();
                    this.tooltipStyle = {
                        top: (rect.top + (rect.height / 2)) + 'px',
                        left: (rect.left - 10) + 'px'
                    };

                    // Auto-close after 3 seconds
                    if (this.tooltipTimers[key]) {
                        clearTimeout(this.tooltipTimers[key]);
                    }
                    this.tooltipTimers[key] = setTimeout(() => {
                        this.tooltips[key] = false;
                    }, 3000);
                }
            },
        }
        ,
        computed: {
            iscritti() {
                return this.$store.getters.iscritti
            },check_wire_no_pay() {
                if(this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms )>0){
                    if(this.form.don_extra === "0"){
                       return true
                    }
                }
                return false
            },adultoCompetitivo() {
                return ((this.form.categoria === 'adulto-competitivo'
                    || this.form.categoria === 'donna-in-rosa-competitiva')
                    && this.eta >= 15)
            },
            richiedeTessera() {
                return this.adultoCompetitivo && (this.form.societa === 'fidal' || this.form.societa === 'EPS')
            },
            eta() {
                // if (!this.ok_data_nascita)
                if (!this.state('data_nascita'))
                    return 18;
                if (this.form.data_nascita === null)
                    return 18;

                let pattern = /(\d{2})-(\d{2})-(\d{4})/;
                let dt = new Date(this.form.data_nascita.replace(pattern, '$3-$2-$1'));
                return this.getAge(dt);
            },
            eta_attuale() {
                // if (!this.ok_data_nascita)
                if (!this.state('data_nascita'))
                    return 18;
                if (this.form.data_nascita === null)
                    return 18;

                let pattern = /(\d{2})-(\d{2})-(\d{4})/;
                let dt = new Date(this.form.data_nascita.replace(pattern, '$3-$2-$1'));
                return this.getActualAge(dt);
            },
            step_ok_donextra() {
                if (this.form.don_extra === null) return false
                if (this.form.don_extra === null && this.wire_transfer === true && (this.wire_transfer_register_limit-this.registered_users - this.number_of_forms)>0) return true
                if (this.form.don_extra === 'extra') {
                    if (this.form.don_extra_importo <= 0) return false
                }
                if (this.form.don_extra === 'gold_extra') {
                    if (this.form.don_gold_extra < this.gold_amount ) return false
                } 
                return true
            },
            check_tshirt_size() {
                if(this.form.data_nascita) {
                    let pattern = /(\d{2})-(\d{2})-(\d{4})/;
                    let dt = new Date(this.form.data_nascita.replace(pattern, '$3-$2-$1'));
                    if(this.getAge(dt) >= 15) {
                        return 'adult'
                    } else if(this.getAge(dt) < 15) {
                        return 'kid'
                    } else {
                        return 'Error'
                    }
                } else {
                    return false
                }
            },
            gold_check() {
                if (this.form.don_extra === 'gold_extra') {
                    if (this.form.don_gold_extra < this.gold_amount ) return false
                }
                return true
            }
            ,
            id_race() {
                return this.$store.state.id_race
            },imposta_maglia()
            {
                return this.$store.getters.imposta_maglia(this.form.id)
            },scaglione_maglia()
            {
                return this.$store.getters.scaglione_maglia(this.form.id)
            },maglia()
            {
                return this.$store.getters.maglia
            }, donna_in_rosa() {
                return this.form.categoria === 'donna-in-rosa' || this.form.categoria === 'donna-in-rosa-competitiva'
            },
            minore() {
                return this.eta_attuale < 18
            },
            check_privacy() {
                if (this.is_regalo) return true // Se è un iscrizione regalo non ci sono i consensi privacy perchè li deve dare il ricevente
                if (!this.prima_iscrizione && !this.minore) return true // Se non è la sua prima iscrizione, non deve confermare niente
                if (this.eta_attuale >= 18 && this.form.check_generico === null) return false // Se invece è la prima iscrizione, il check generico c'è per tutti
                if (this.minore && this.form.check_minore === null) return false
                if (this.donna_in_rosa && this.form.check_salute === null) return false
                return true
            },
            check_maglia() {
                if (!this.form.maglia) return true
                if (!this.imposta_maglia) return true
                if (!this.compiled('maglia_nome','maglia_cognome','maglia_indirizzo','maglia_cap')) return false
                if (!this.compiled('maglia_citta','maglia_provincia','maglia_cellulare')) return false
                return true
            },
            testi_donazione() {
                let testi = this.$store.state.testi_donazione
                if (testi === null) testi = {}
                return testi
            }, donazione_totale() {
                let extra = 0
                if (this.form.don_extra != null) {
                    if (this.form.don_extra === 'extra') {
                        extra = parseInt(this.form.don_extra_importo)
                        if (isNaN(extra)){
                          extra = 0  
                        }
                    } else {
                        extra = parseInt(this.form.don_extra)
                    }
                }
                if (this.form.don_gold_extra != null && this.form.don_gold_extra != "") {
                    if (this.form.don_extra === 'gold_extra') {
                        extra = parseInt(this.form.don_gold_extra)
                        if (isNaN(extra)) extra = 0
                    } else
                        extra = parseInt(this.form.don_gold_extra)
                }
                if (this.form.maglia && this.scaglione_maglia)
                    return this.testi_donazione.base + this.testi_donazione.con_maglia + extra

                if(this.wire_transfer === true) {
                    return extra
                }
                return this.testi_donazione.base + extra
            }, conMaglia() {
                return this.$store.getters.con_maglia
            }, donazione_base() {
                if (this.form.maglia && this.scaglione_maglia)
                    return this.testi_donazione.base + this.testi_donazione.con_maglia
                else
                    return this.testi_donazione.base
            }, is_regalo() {
                return  this.$store.getters.is_regalo
            }, changeDonatoreEmail() {
                if (!this.state('donatore_email')) return
                this.form.email = this.form.donatore_email
            }
        }
    }
</script>

<style scoped>
    .v-tooltip-trigger {
        display: inline-block;
        width: 24px !important;
        height: 24px !important;
        line-height: 24px !important;
        text-align: center;
        background: #f0f0f0;
        border-radius: 50%;
        cursor: pointer;
        margin-right: 6px;
        position: relative;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        z-index: 1000;
    }

    .custom-tooltip {
        position: fixed;
        transform: translate(-100%, -50%);
        background: #333;
        color: white;
        padding: 6px 12px;
        border-radius: 4px;
        font-size: 13px;
        line-height: 1.4;
        white-space: normal;
        max-width: 250px;
        z-index: 10000;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        margin-right: 10px;
    }
    .custom-tooltip-size{
        min-width: 100px !important;
        position: absolute;
        top: 50%;
        left: -5px;
    }

    .custom-tooltip::before {
        content: '';
        position: absolute;
        right: -4px;
        top: 50%;
        transform: translateY(-50%);
        border-top: 4px solid transparent;
        border-bottom: 4px solid transparent;
        border-left: 4px solid #333;
    }

    @media (max-width: 768px) {
        .v-tooltip-trigger {
            width: 30px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
        }
        
        .custom-tooltip {
            font-size: 12px;
            padding: 5px 10px;
        }
    }
    .tooltip {
        z-index: 10000 !important;
    }
    .tooltip-inner {
        max-width: 300px !important;
        padding: 8px 12px !important;
    }
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    @media only screen and (max-width: 500px) {
        .k-card-text {
            width: 100% !important;
        }
        .k-card-img {
            height: 100% !important;
            width: 100% !important;
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }
    @media only screen and (max-width: 768px) and (min-width: 500px) {
        .k-card-text {
            width: 100% !important;
        }
        .k-card-img {
            float:left !important;
        }
    }
</style>
